import { TreesStatsOutput } from '@allocab/allocab-passenger-shared-types';
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';

import { queryKeys } from '../services/datastore/queryKeys';
import { DEFAULT_CACHE_TIME, queryClient } from '../services/datastore/react-query';
import { passengerApi } from '../services/network/Api';

const fetchUserTrees = () => passengerApi.get<unknown, TreesStatsOutput>('/user/v1/trees');

export const useFetchUserTrees = () =>
  useQuery(queryKeys.user.fetchUserTrees(), () => fetchUserTrees(), { staleTime: DEFAULT_CACHE_TIME });

export const usePrefetchUserTrees = () => {
  useEffect(() => {
    queryClient.prefetchQuery(queryKeys.user.fetchUserTrees(), () => fetchUserTrees());
  }, []);
};
